import React from 'react';
import { bool } from 'prop-types';
import { Loader } from '@tesla/design-system-react';

const propTypes = { show: bool };

const defaultProps = { show: false };

const GlobalLoader = ({ show }) => (show ? <Loader show /> : null);

GlobalLoader.propTypes = propTypes;
GlobalLoader.defaultProps = defaultProps;

export default GlobalLoader;
